// extracted by mini-css-extract-plugin
export default {"container":"layout_container_x","expandColumn":"layout_container_expandColumn"};